import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AuthGuard} from './auth.guard';
import {StorageService} from './storage.service';
import {HelperService} from './helpers';
import {TokenInterceptorService} from './token.interceptor.service';
import {AccordionModule, TabsModule, TooltipModule, TypeaheadModule} from 'ngx-bootstrap';
import {ContractorComponent} from './content/contractor/contractor.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {UnitComponent} from './content/unit/unit.component';
import {TimetableComponent} from './content/timetable/timetable.component';
import {PremiumComponent} from './content/premium/premium.component';
import {QuillModule} from 'ngx-quill';

import {APP_BASE_HREF, CurrencyPipe, registerLocaleData} from '@angular/common';
import localeSl from '@angular/common/locales/sl';
import { PremiumFlyerComponent } from './content/premium-flyer/premium-flyer.component';
import {CacheService} from './cache.service';
import { PasswordRenewComponent } from './password-renew/password-renew.component';
import { ChangePasswordComponent } from './content/change-password/change-password.component';
import {environment} from '../environments/environment';

registerLocaleData(localeSl, 'sl');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    ContractorComponent,
    UnitComponent,
    TimetableComponent,
    PremiumComponent,
    PremiumFlyerComponent,
    PasswordRenewComponent,
    ChangePasswordComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule.forRoot(),
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    AccordionModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{list: 'ordered'}, {list: 'bullet'}],
          ['link']
        ],
      }
    })
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue : environment.baseUrl },
    AuthGuard,
    StorageService,
    HelperService,
    CurrencyPipe,
    CacheService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
